(function($, Drupal, drupalSettings) {

  Drupal.behaviors.mbo_form = {
    attach: function (context, settings) {

      /**
      * Select2 error response
      * https://select2.org/
      */
      $('body', context).once('select-events').on('change', '.webform-submission-form select', function() {
        // If populated remove .error from select, label & .select2-dropdown //
        if ($(this).val()) {
          $('label.error', $(this).closest('.form-item')).remove();
        }
      });


      /**
      * Tooltip properties
      * https://api.jqueryui.com/tooltip/
      */
      $(window).on('load', function() {
        if ( $('.webform-element-help', context).length ) {
          $('.webform-element-help', context).once('tooltip').tooltip({
            position: {
              my: 'right+3 bottom-11',
              at: 'right+3 top',
              using: function(position, feedback) {
                $(this).css(position);
                // Add arrow position CSS class //
                if (feedback.target.left <= feedback.element.width && feedback.element.left > 30)  {
                  $(this).addClass('arrow--left');
                } else {
                  $(this).addClass('arrow--right');
                }

                if (feedback.target.top >= feedback.element.top ) {
                  $(this).addClass('arrow--bottom');
                } else {
                  $(this).addClass('arrow--top');
                }

              }
            },
            classes: {
              'ui-tooltip': 'mba_form_007'
            },
          });
        }
      });

      $('.mba_form_008a,.mba_form_008b').find('label').once().prepend($('<span class="slider"></span>'));

      /**
      * Radio & checkbox make checked
      */
      //  Keypress enter //
      $('body', context).once('radio-cb-event').on('keypress', '.form-type-radio input, .form-type-checkbox input', function(e) {

        // Trigger click on enter //
        if ( e.which == 13 && $(this).is(':focus') ) $(this).siblings('label').trigger('click');
        return false;

      });


      /**
      * Fieldset input auto focus
      */
      var inputElement = 'fieldset input:not([type=radio])';

      // Keypress //
      $('body', context).once('fieldset-focus-next').on('keyup', inputElement, function(e) {

        var $this = $(this);
        var thisNextInput = $this.closest('div').next().find('input');
        var thisVal = $this.val().length;
        var thisMaxLength = parseInt($this.attr('maxlength'), 10);

        // Move focus to next input //
        if ( thisVal >= thisMaxLength ) {
          thisNextInput.focus();
        }

      });

      // Keydown //
      $('body', context).once('fieldset-focus-prev').on('keydown', inputElement, function(e) {

        var $this = $(this);
        var thisPrevInput = $this.closest('div').prev().find('input');
        var thisVal = $this.val();

        // Backspace key //
        if ( e.keyCode == 8 ) {
          // Move focus to previous input //
          if ( thisVal.length == 0 ) {
            thisPrevInput.focus();
          }
        }

      });


      /**
      * Add CSS class to valid AJAX submit button for throbber styling.
      */
      $('.webform-ajax-form-wrapper input[type="submit"]').on('click', function(event) {

        $this = $(this);

        setTimeout(function() {
          if ( !$('form').hasClass('ajax-submit-prevented') ) $this.closest('div').addClass('throbber-active');
        }, 0);

      });


      /**
       * Date picker customisations, right align, date suffix and css class.
       */
      if ($('.form-item.form-type-date').length) {
        modifyDatepickers();
      }
      function modifyDatepickers() {
        if ($('.form-item.form-type-date input:not(.hasDatepicker):not(.altDatepicker)').length) {
          setTimeout(function () {
            modifyDatepickers();
          }, 100);
          return false;
        }

        $('.form-item.form-type-date input.hasDatepicker:not(.datePickered)').each(function (index, value) {
          // Flag element as modified.
          $(value).addClass('datePickered');

          // Make alternate input to hold date format that allows the suffix.
          if (!$('> input.altDatepicker', $(value).closest('.form-item.form-type-date')).length) {
            var formattedVal = $(value).val();
            if ($(value).hasClass('with-suffix')) {
              formattedVal = dateWithSuffix(formattedVal);
            }
            $(value).attr('readonly', 'readonly');
            $(value).before('<input type="text" readonly="readonly"  id="' + $(value).attr('id') + '__altdatepicker" value="' + formattedVal + '" class="form-text altDatepicker" />');
            $(value).closest('.form-item.form-type-date').addClass('withAltDatepicker');
          }

          // Customisations to the webform settings.
          var datePickerCustomisations = {
            beforeShow: function(input, inst) {
              // Add class for focus and border radius tweak.
              $(this).addClass('showingDatepicker');
              $('> input.altDatepicker', $(this).closest('.form-item.form-type-date')).addClass('showingDatepicker');

              // Make picker right aligned to the input.
              var widget = $(inst).datepicker('widget');
              widget.css('margin-left', $(input).outerWidth() - widget.outerWidth());

              // Make picker always go below the input.
              setTimeout(function () {
                var widget = $(inst).datepicker('widget');
                widget.css('top', $('input.hasDatepicker.showingDatepicker').offset().top);
              }, 0);
            },
            onSelect: function(dateText, inst) {
              $(this).removeClass('showingDatepicker');

              var formattedVal = $(this).val();
              if ($(this).hasClass('with-suffix')) {
                formattedVal = dateWithSuffix(formattedVal);
              }
              $('> input.altDatepicker', $(this).closest('.form-item.form-type-date')).val(formattedVal).removeClass('showingDatepicker');
              $(this).trigger('change');
            },
            onClose: function(dateText, inst) {
              $(this).removeClass('showingDatepicker');

              var formattedVal = $(this).val();
              if ($(this).hasClass('with-suffix')) {
                formattedVal = dateWithSuffix(formattedVal);
              }
              $('> input.altDatepicker', $(this).closest('.form-item.form-type-date')).val(formattedVal).removeClass('showingDatepicker');
            }
          };

          if ($(value).attr('min')) {
            var min = new Date(Date.parse($(value).attr('min').replace('th ', ' ').replace('st ', ' ').replace('nd ', ' ').replace('Augu ', 'August ')));
            datePickerCustomisations.minDate = min;
          }
          if ($(value).attr('max')) {
            var max = new Date(Date.parse($(value).attr('max').replace('th ', ' ').replace('st ', ' ').replace('nd ', ' ').replace('Augu ', 'August ')));
            datePickerCustomisations.maxDate = max;
          }

          $(value).customizeDatepicker(datePickerCustomisations);
        });
      }
      $('body', context).once('datepicker-events').on('change', 'input.hasDatepicker', function() {
        if ($(this).val() != '') {
          $('> input', $(this).closest('.form-item')).removeClass('error');
          $('label.error', $(this).closest('.form-item')).remove();
          $(this).closest('.form-item').removeClass('datepickerError');
        } else {
          $('> input', $(this).closest('.form-item')).addClass('error');
          $(this).closest('.form-item').addClass('datepickerError');
        }
      });
      $('body', context).once('datepicker-webform-submit-event').on('click', '.webform-submission-form input[type="submit"]', function() {
        setTimeout(function(){
          $('.form-item.form-type-date input.hasDatepicker').each(function (index, value) {
            if ($(value).hasClass('error')) {
              $('> input.altDatepicker', $(value).closest('.form-item')).addClass('error');
              $(value).closest('.form-item').addClass('datepickerError');
            } else {
              $('> input.altDatepicker', $(value).closest('.form-item')).removeClass('error');
              $('label.error', $(this).closest('.form-item')).remove();
              $(value).closest('.form-item').removeClass('datepickerError');
            }
          });
        }, 1);
      });

      function dateWithSuffix(val) {
        var formattedVal = val.split(' ');
        if (formattedVal.length !== 3) {
          return '';
        }
        formattedVal[0].replace('th', '').replace('st', '').replace('nd', '');

        var suffix = "";
        switch(formattedVal[0]) {
          case '1': case '21': case '31': suffix = 'st'; break;
          case '2': case '22': suffix = 'nd'; break;
          case '3': case '23': suffix = 'rd'; break;
          default: suffix = 'th';
        }

        return formattedVal[0] + suffix + ' ' + formattedVal[1] + ' ' + formattedVal[2];
      }


      /**
      * Accordion fieldset using custom CSS class of paragraph-type-mbo-accordion-001.
      * Using the mbf_accordion library.
      */
      $('fieldset.paragraph-type-mbo-accordion-001 legend', context).once('form-accordion').mbf_accordion({
        accordionItem: 'fieldset',
        slideElement: '.fieldset-wrapper',
        parentItem: 'fieldset',
      });


      /**
      * Set autocomplete to off for browsers that don't support autocompelet=off attribute.
      */
      $('body').once('webform-autocomplete-off').on('focus', '.webform-submission-form input[autocomplete]', function() {
        $(this).attr('autocomplete', 'off');
      });


      /**
      * mbm_form_006a: Open and close checkbox list.
      */
      $('.mbm_form_006a .description', context).once('open-list').on('click', function() {
        $this = $(this);
        $cbs = $this.closest('.mbm_form_006a');
        $cbs.toggleClass('open');
        $('.webform-panel').getNiceScroll().resize();
      });


      /**
      * mbm_form_006a: Validation.
      */
      $('.webform-button--submit', context).once('validate-mbm-form-006').on('click', function() {

        var $this = $(this);
        var formId = $this.closest('form').attr('id');
        var classList = $('.mbm_form_006a').attr("class").split(/\s+/);

        $.each(classList, function(index, value) {
          if (value.indexOf('required') >= 0) {

            var parts = value.split('-');
            var cbList = $('.' + value)
            var cbChecked = cbList.find('input[type="checkbox"]:checked');

            if (cbChecked.length == 0) {
              cbList.addClass('error');
              $('#' + formId).submit(function(e){ e.preventDefault(); });
            } else {
              $('#' + formId)[0].submit();
            }

          }
        });

      });

      /**
      * mbm_form_006a: Disable checkboxes depending on required number.
      */
      $('.mbm_form_006a input[type="checkbox"]', context).once('disable-enable-cbs').on('click', function() {

        var $this = $(this);
        var classList = $('.mbm_form_006a').attr("class").split(/\s+/);
        var cbChecked = $('.mbm_form_006a input[type="checkbox"]:checked');

        $.each(classList, function(index, value) {
          if (value.indexOf('required') >= 0) {

            var parts = value.split('-');
            var cbList = $('.' + value);

            if (cbChecked.length >= parts[1]) {
              cbList.removeClass('error');
              $('.mbm_form_006a input[type="checkbox"]:not(:checked)').each(function() {
                $(this).closest('.form-type-checkbox').addClass('disabled');
              });
            } else {
              $('.mbm_form_006a input[type="checkbox"]:not(:checked)').each(function() {
                $(this).closest('.form-type-checkbox').removeClass('disabled');
              });
            }

          }
        });

      });


    }
  }; // Drupal.behaviors.mbo_form

  $.fn.customizeDatepicker = function(newOptions) {
    var prevOptions = $(this).datepicker('option', 'all');
    $(this).datepicker('destroy').datepicker($.extend(prevOptions, newOptions));
    return this;
  };

})(jQuery, Drupal, drupalSettings);
